export const mainIndent = '15px';

// export const BASE_URL = 'https://unilink.us';

export const BaseUrlTest = 'https://unilink-web-dev.azurewebsites.net';
export const BaseUrlProd = 'https://unilink.us';
export const NextUrl = 'https://unil.ink';

export const BASE_URL = BaseUrlProd;

export const linkDesignTypes = {
  button: 'button',
  round: 'round',
  square: 'square',
  full: 'full',
  cover: 'cover',
  card: 'card',
  ticket: 'ticket',
};

export const IMAGE_SIZES = {
  squareSmall: 'ss_',
  squareMedium: 'ms_',
  squareLarge: 'ls_',
  originalSmall: 'gs_',
  originalMedium: 'gm_',
  originalLarge: 'gl_',
};

export const VIEW = {
  compact: 'compact',
  card: 'card',
  button: 'button',
  list: 'list',
  hero: 'hero',
  fanRipping: 'fan-ripping',
};

// `label` is the canonical English name used by language-agnostic surfaces
// (JSON-LD schema.org Person.knowsAbout, discovery URLs). `translateKey`
// drives the user-facing chip label via translation.wizard[key].
export const PROFILE_CATEGORIES = [
  { type: 'blog', translateKey: 'blog', label: 'Blog' },
  { type: 'creator', translateKey: 'creator', label: 'Creator' },
  { type: 'music', translateKey: 'music', label: 'Music' },
  { type: 'events', translateKey: 'events', label: 'Events' },
  { type: 'esoteric', translateKey: 'esoteric', label: 'Esoteric' },
  { type: 'fashion', translateKey: 'fashion', label: 'Fashion' },
  { type: 'influencer', translateKey: 'influencer', label: 'Influencer' },
  { type: 'food', translateKey: 'food', label: 'Food' },
  { type: 'small-business', translateKey: 'smallBusiness', label: 'Small Business' },
  { type: 'marketing', translateKey: 'marketing', label: 'Marketing' },
  { type: 'education', translateKey: 'education', label: 'Education' },
  { type: 'social-media', translateKey: 'socialMedia', label: 'Social Media' },
  { type: 'coaching', translateKey: 'coaching', label: 'Coaching' },
  { type: 'ecommerce', translateKey: 'ecommerce', label: 'Ecommerce' },
  { type: 'health-and-fitness', translateKey: 'healthAndFitness', label: 'Health and Fitness' },
  { type: 'beauty-wellness', translateKey: 'beautyWellness', label: 'Beauty & Wellness' },
];

export const SHAPE = {
  square: 'square',
  round: 'round',
};

export const SHAPE_DATA = {
  none: 'none',
  noneValue: '0px',
  small: 'small',
  smallValue: '4px',
  medium: 'medium',
  mediumValue: '8px',
  large: 'large',
  largeValue: '16px',
  round: 'round',
  roundValue: '36px',
};

export const BORDER = {
  none: 'none',
  thin: 'thin',
  solid: 'solid',
  double: 'double',
};

export const SHADOW = {
  none: 'none',
  subtle: 'subtle',
  soft: 'soft',
  hard: 'hard',
};

export const ANIMATIONS = {
  none: 'none',
  pulse: 'pulse',
  shake: 'shake',
  tada: 'tada',
  bounceIn: 'bounceIn',
  fadeIn: 'fadeIn',
  flipInX: 'flipInX',
  flipInY: 'flipInY',
  zoomIn: 'zoomIn',
  swing: 'swing',
  jello: 'jello',
  beat: 'beat',
  blink: 'blink',
  borderFlow: 'borderFlow',
};

export const REWARD_TYPES = {
  text: 'text',
  file: 'file',
  link: 'link',
  code: 'code',
};

export const HEADER_BUTTONS_TYPES = {
  cta: 'cta',
  cart: 'cart',
  message: 'message',
  subscribe: 'subscribe',
  contact: 'contact',
  qrcode: 'qrcode',
  language: 'language',
};

export const LANGUAGE_FLAGS = {
  en: '🇺🇸',
  uk: '🇺🇦',
  de: '🇩🇪',
  fr: '🇫🇷',
  es: '🇪🇸',
  pl: '🇵🇱',
  it: '🇮🇹',
  pt: '🇧🇷',
  ar: '🇸🇦',
  'zh-CN': '🇨🇳',
  ja: '🇯🇵',
  tr: '🇹🇷',
};

export const LANGUAGE_NAMES = {
  en: 'English',
  uk: 'Українська',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  pl: 'Polski',
  it: 'Italiano',
  pt: 'Português',
  ar: 'العربية',
  'zh-CN': '中文',
  ja: '日本語',
  tr: 'Türkçe',
  hu: 'Magyar',
};

export const LANGUAGE_DISPLAY_TYPES = {
  abbreviation: 'abbreviation',
  language: 'language',
  icon: 'icon',
  flag: 'flag',
};

export const TRACK_ACTIONS = {
  // Header
  clickHeaderExternalLink: 'ClickHeaderExternalLink',
  clickHeaderSubscribe: 'ClickHeaderSubscribe',
  submitHeaderSubscribe: 'SubmitHeaderSubscribe',
  clickHeaderMessage: 'ClickHeaderMessage',
  submitHeaderMessage: 'SubmitHeaderMessage',
  clickHeaderContact: 'ClickHeaderContact',
  clickHeaderCart: 'ClickHeaderCart',
  clickHeaderCta: 'ClickHeaderCta',
  clickHeaderQrcode: 'ClickHeaderQrcode',
  clickHeaderLanguage: 'ClickHeaderLanguage',
  viewHeaderSocialLink: 'ViewHeaderSocialLink',
  clickHeaderSocialLink: 'ClickHeaderSocialLink',
  clickHeaderLocation: 'ClickHeaderLocation',
  clickHeaderCoverCta: 'ClickHeaderCoverCta',

  // Text
  viewText: 'ViewText',
  clickTextCta: 'ClickTextCta',

  //Form
  clickFormCta: 'ClickFormCta',
  viewForm: 'ViewForm',

  // Link
  viewAllLink: 'ViewAllLink',
  viewLink: 'ViewLink',
  clickLink: 'ClickLink',
  visitLink: 'VisitLink',
  clickLinkPurchase: 'ClickLinkPurchase',
  submitLink: 'SubmitLink',

  visitPage: 'VisitPage',

  //Contact
  clickContact: 'ClickContact',
  viewContact: 'ViewContact',

  //FAQ
  viewFaq: 'ViewFaq',
  clickFaqCta: 'ClickFaqCta',
  clickFaqExternalLink: 'ClickFaqExternalLink',

  // Highlight
  viewHighlightAll: 'ViewHighlightAll',
  clickHighlightLink: 'ClickHighlightLink',
  clickHighlightExternalLink: 'ClickHighlightExternalLink',

  // Banner
  clickBannerCta: 'ClickBannerCta',
  clickBannerExternalLink: 'ClickBannerExternalLink',

  // Slider
  viewSliderAll: 'ViewSliderAll',
  clickSliderCta: 'ClickSliderCta',
  clickSliderExternalLink: 'ClickSliderExternalLink',

  // Gallery
  viewGalleryAll: 'ViewGalleryAll',
  viewGalleryMedia: 'ViewGalleryMedia',
  clickGalleryExternalLink: 'ClickGalleryExternalLink',

  // Blog
  viewBlogAll: 'ViewBlogAll',
  clickBlog: 'ClickBlog',
  visitBlog: 'VisitBlog',
  clickBlogPurchase: 'ClickBlogPurchase',
  submitBlog: 'SubmitBlog',
  clickBlogExternalLink: 'ClickBlogExternalLink',

  // Map
  viewMapAll: 'ViewMapAll',
  viewMap: 'ViewMap',
  clickMap: 'ClickMap',
  copyMap: 'CopyMap',
  clickMapExternalLink: 'ClickMapExternalLink',

  submitDigital: 'SubmitDigital',

  // Form
  submitForm: 'SubmitForm',

  // Shop
  viewShop: 'ViewShop',
  clickShop: 'ClickShop',

  // Digital
  viewDigital: 'ViewDigital',
  clickDigital: 'ClickDigital',

  // Appointment
  viewAppointment: 'ViewAppointment',
  clickAppointment: 'ClickAppointment',

  // Booking
  viewBooking: 'ViewBooking',
  clickBooking: 'ClickBooking',

  // Service
  viewService: 'ViewService',
  clickService: 'ClickService',

  // Donation
  viewDonation: 'ViewDonation',
  clickDonation: 'ClickDonation',

  // Course
  viewCourse: 'ViewCourse',
  clickCourse: 'ClickCourse',

  // Event
  viewEvent: 'ViewEvent',
  clickEvent: 'ClickEvent',

  // Membership
  viewMembership: 'ViewMembership',
  clickMembership: 'ClickMembership',

  // Coupon
  viewCoupon: 'ViewCoupon',
  clickCoupon: 'ClickCoupon',

  // Instagram
  viewInstagram: 'ViewInstagram',
  clickInstagram: 'ClickInstagram',

  // TikTok
  viewTikTok: 'ViewTikTok',

  // YouTube
  viewYouTube: 'ViewYouTube',
  clickYouTube: 'ClickYouTube',

  // Twitter
  viewTwitter: 'ViewTwitter',

  // Music
  viewMusic: 'ViewMusic',

  // Twitch
  viewTwitch: 'ViewTwitch',

  // Video
  viewVideo: 'ViewVideo',

  // Review
  viewReview: 'ViewReview',

  // Trust
  viewTrust: 'ViewTrust',

  // Timetable
  viewTimetable: 'ViewTimetable',

  // Features
  viewFeatures: 'ViewFeatures',

  // Pricing
  viewPricing: 'ViewPricing',

  // DataCollect
  viewDataCollect: 'ViewDataCollect',
  submitDataCollect: 'SubmitDataCollect',

  // Poll
  viewPoll: 'ViewPoll',
  submitPoll: 'SubmitPoll',

  // Apps
  viewApps: 'ViewApps',
  clickApp: 'ClickApp',

  // File
  viewFile: 'ViewFile',
  clickFile: 'ClickFile',

  // Wallet
  viewWallet: 'ViewWallet',

  // NFT
  viewNft: 'ViewNft',

  // Timer
  viewTimer: 'ViewTimer',

  // Outfit
  viewOutfit: 'ViewOutfit',

  // Menu
  viewMenu: 'ViewMenu',

  // Banner (view)
  viewBanner: 'ViewBanner',

  // Slider (view)
  viewSlider: 'ViewSlider',

  // Gallery (view)
  viewGallery: 'ViewGallery',

  // Blog (view)
  viewBlog: 'ViewBlog',

  // Map (view - block level)
  viewMapBlock: 'ViewMapBlock',

  // Links (view - block level)
  viewLinks: 'ViewLinks',

  // Contacts (view - block level)
  viewContacts: 'ViewContacts',

  // FAQ (view - block level)
  viewFaqBlock: 'ViewFaqBlock',

  // Highlights (view - block level)
  viewHighlights: 'ViewHighlights',

  // Canonical block-level view actions for blocks that previously fell back to "View{type}"
  viewPodcast: 'ViewPodcast',
  viewTips: 'ViewTip',
  viewRental: 'ViewRentalAll',
  viewChatAi: 'ViewChatAi',
  viewRecipe: 'ViewRecipe',
  viewAma: 'ViewAma',
  viewGuestbook: 'ViewGuestbook',
  viewLiveStream: 'ViewLiveStream',
  viewWorkout: 'ViewWorkout',
  viewVideoFeedback: 'ViewVideoFeedback',
  viewPremiumInbox: 'ViewPremiumInbox',
  viewCustom: 'ViewCustom',

  // Detailed engagement events (batched via trackQueue; Value carries the metric)
  dwellBlock: 'DwellBlock', // Value = seconds a block spent in viewport
  scrollDepth: 'ScrollDepth', // Value = percent of page scrolled (25/50/75/100)

  // Sub-item impressions (a specific item in a list block entered the viewport; itemId = the item)
  impressionLink: 'ImpressionLink',
  impressionShop: 'ImpressionShop',
  impressionDigital: 'ImpressionDigital',
  impressionGallery: 'ImpressionGallery',
  impressionHighlight: 'ImpressionHighlight',
  impressionMenu: 'ImpressionMenu',
  impressionTimetable: 'ImpressionTimetable',
  impressionTeam: 'ImpressionTeam',

  // Media playback (Value = percent watched for progress events)
  playVideo: 'PlayVideo',
  progressVideo: 'ProgressVideo',
  pauseVideo: 'PauseVideo',
  playMusic: 'PlayMusic',
  progressMusic: 'ProgressMusic',
  playPodcast: 'PlayPodcast',
  progressPodcast: 'ProgressPodcast',

  // Downloads (started)
  downloadFile: 'DownloadFile',
  downloadDigital: 'DownloadDigital',
  downloadMusic: 'DownloadMusic',

  // Item clicks for blocks that navigate internally (delegated click tracking)
  clickTrust: 'ClickTrustExternalLink',
  clickTimetable: 'ClickTimetable',
  clickReview: 'ClickReviewExternalLink',
  clickOutfit: 'ClickOutfit',
  clickPricing: 'ClickPricing',
  clickNft: 'ClickNftExternalLink',
  clickRental: 'ClickRental',
};

export const BLOCK_TYPES = {
  links: 'link',
  text: 'text',
  header: 'header',
  dataCollect: 'data-collect',
  poll: 'poll',
  apps: 'apps',
  form: 'form',
  contacts: 'contact',
  faq: 'faq',
  features: 'feature',
  highlights: 'highlight',
  banner: 'banner',
  slider: 'slider',
  gallery: 'gallery',
  footer: 'footer',
  splash: 'splash',
  blog: 'blog',
  promo: 'promo',
  map: 'map',

  shop: 'shop',
  digital: 'digital',
  appointment: 'appointment',
  booking: 'booking',
  rental: 'rental',
  service: 'service',
  donation: 'donation',
  tips: 'tip',
  course: 'course',
  event: 'event',
  membership: 'membership',
  pricing: 'pricing',
  wallet: 'wallet',

  instagram: 'instagram',
  tiktok: 'tiktok',
  youtube: 'youtube',
  twitter: 'twitter',
  music: 'music',
  twitch: 'twitch',

  review: 'review',
  trust: 'trust',
  coupon: 'coupon',
  spacer: 'spacer',
  outfit: 'outfit',
  html: 'html',
  timer: 'timer',
  timetable: 'timetable',
  nft: 'nft',
  menu: 'menu',
  custom: 'custom',
  chatAi: 'chat-ai',

  video: 'video',
  orderForm: 'order-form',
  wall: 'wall',
  livestream: 'live-stream',
  workout: 'workout',
  ama: 'ama',
  videoFeedback: 'video-feedback',
  premiumInbox: 'premium-inbox',
  podcast: 'podcast',
};

export const ACTIONS = {
  none: 'none',
  page: 'page',
  email: 'email',
  redirect: 'redirect',
  display: 'display',
  send: 'send',
  text: 'text',
};

export const DESKTOP_MODE = {
  // New names
  classic: 'classic',
  social: 'social',
  // Legacy aliases (backward compatibility)
  mobile: 'classic',
  desktop: 'social',
};

export const IMAGE_PREFIX = {
  squareS: 'ss_',
  squareM: 'ms_',
  squareL: 'ls_',
  originalS: 'gs_',
  originalM: 'gm_',
  originalL: 'gl_',
};

export const DEFAULT_ITEM_DESIGN = {
  backgroundColor: '#ffffff',
  textColor: '#000000',
  opacity: 0,
  shape: 'none',
  border: 'none',
  borderColor: '#ECECF0',
  shadow: 'none',
  shadowColor: '#000000',
};

export const DEFAULT_ITEM_BUTTON_DESIGN = {
  align: 'left',
  style: 'filled',
  backgroundColor: '#ffffff',
  textColor: '#000000',
  opacity: 0,
  shape: 'none',
  border: 'none',
  borderColor: '#ECECF0',
  shadow: 'none',
  shadowColor: '#000000',
};

export const MAPBOX_TOKEN = 'pk.eyJ1IjoibW9ycGhociIsImEiOiJjbW5oaTB3a28wMGdtMndza2IxanphNDFxIn0.V7AcBxSZ_HiYpKvajRyOfw';
